import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AddressFormFields, ButtonBar, Input, LifeSaverForm
} from '../../components';

import { ScreenHeader } from '.';

export function NewHDPhysicianInformation() {
  const navigate = useNavigate();
    
  const handleBack = useCallback(() => {
    // Handle back navigation
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../healthcare-agent');
  }, [ navigate ]);

  return (
    <div className="new-fa-disposition">
      <ScreenHeader 
        title="Physician Information"
        description="Provide information about your primary physician and medical care providers."
        steps={6}
        step={6}
        handleBack={handleBack}
      />

      <LifeSaverForm 
        icon="clinical_notes"
        header="Primary Care Physician"
      >
        <Input 
          label="First Name"
          name="physicianFirstName"
          placeholder="Enter your physician's first name"
          required
        />
        <Input 
          label="Last Name"
          name="physicianLastName"
          placeholder="Enter your physician's last name"
          required
        />
        <AddressFormFields address={{}}/>
      </LifeSaverForm>

      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}